// --- 1. Gestion des vidéos (UGC Play/Pause) ---
function toggleVideo(overlay) {
  const video = overlay.previousElementSibling;
  const icon = overlay.querySelector("svg path");

  // Mettre les autres vidéos en pause
  document.querySelectorAll(".gallery__item video").forEach((v) => {
    if (v !== video) {
      v.pause();
      v.nextElementSibling.style.display = "flex";
      v.nextElementSibling.querySelector("svg path").setAttribute("d", "M8 5v14l11-7z");
    }
  });

  if (video.paused) {
    video.play();
    overlay.style.display = "none";
  } else {
    video.pause();
    overlay.style.display = "flex";
    icon.setAttribute("d", "M8 5v14l11-7z"); // Icône lecture
  }
}

document.querySelectorAll(".gallery__item video").forEach((video) => {
  video.setAttribute("preload", "auto");
  video.addEventListener("click", function () {
    //Mettre en pause les autres videos
    document.querySelectorAll(".gallery__item video").forEach((v) => {
      if (v !== video) {
        v.pause();
        v.nextElementSibling.style.display = "flex";
        v.nextElementSibling.querySelector("svg path").setAttribute("d", "M8 5v14l11-7z"); // Icône lecture
      }
    });
    if (!this.paused) {
      this.pause();
      const overlay = this.nextElementSibling;
      overlay.style.display = "flex";
      overlay.querySelector("svg path").setAttribute("d", "M6 4h4v16H6zm8 0h4v16h-4z");
    } else {
      this.play();
      const overlay = this.nextElementSibling;
      overlay.style.display = "flex";
      overlay.querySelector("svg path").setAttribute("d", "M6 4h4v16H6zm8 0h4v16h-4z"); // Icône pause
    }
  });
});


// --- 2. Gestion du Scroll Horizontal via les flèches ---
// On boucle sur toutes les galeries présentes sur la page pour éviter les conflits si tu utilises la section 2 fois.
document.querySelectorAll('gallery-list.gallery').forEach((gallerySection) => {
  const scrollContainer = gallerySection.querySelector('.gallery__list.kea-scroll-x');
  const prevBtn = gallerySection.querySelector('.prev-next-button--prev');
  const nextBtn = gallerySection.querySelector('.prev-next-button--next');

  if (scrollContainer && prevBtn && nextBtn) {
    // Fonction dynamique pour calculer la largeur de défilement (1 carte + le gap de 20px)
    const getScrollAmount = () => {
      const firstItem = scrollContainer.querySelector('.gallery__item');
      return firstItem ? firstItem.offsetWidth + 20 : 300; 
    };

    // Action au clic : flèche gauche
    prevBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    // Action au clic : flèche droite
    nextBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    // Écouteur de scroll pour gérer l'attribut "disabled" des boutons (griser quand on est aux extrémités)
    scrollContainer.addEventListener('scroll', () => {
      const isAtStart = scrollContainer.scrollLeft <= 0;
      // Ajout de 2px de tolérance pour le calcul des navigateurs sur le scrollWidth
      const isAtEnd = Math.ceil(scrollContainer.scrollLeft + scrollContainer.clientWidth) >= scrollContainer.scrollWidth - 2;

      // Gestion Flèche Gauche
      if (isAtStart) {
        prevBtn.setAttribute('disabled', 'disabled');
      } else {
        prevBtn.removeAttribute('disabled');
      }

      // Gestion Flèche Droite
      if (isAtEnd) {
        nextBtn.setAttribute('disabled', 'disabled');
      } else {
        nextBtn.removeAttribute('disabled');
      }
    });
  }
});